export enum AppointmentStatus {
  SCHEDULED = "Scheduled",
  COMPLETED = "Completed",
  CANCELLED = "Cancelled",
  RESCHEDULED = "Rescheduled",
  CONFIRMED = "Confirmed",
  IN_QUEUE = "In queue",
  IN_PROGRESS = "In Progress",
  CONSULTED="Consulted",
  DOCTOR_UNAVAILABLE = "Doctor Unavailable"
}
